import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/tokens.css';
import { ThemeProvider } from './theme';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './store/AuthReducer';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from './config';
import * as Sentry from "@sentry/react";

import { clarity } from 'react-microsoft-clarity';

const RESIZE_OBSERVER_LOOP =
  /ResizeObserver loop completed with undelivered notifications|ResizeObserver loop limit exceeded/;

window.addEventListener(
  "error",
  (event) => {
    const message = event.message || event.error?.message || "";
    if (!RESIZE_OBSERVER_LOOP.test(message)) return;
    event.stopImmediatePropagation();
  },
  true
);

if (process.env.REACT_APP_NODE_ENV === 'production') {
  clarity.init(process.env.REACT_APP_CLARITY_ID);
  clarity.identify('USER_ID', { userProperty: 'value' });
  clarity.consent();
  clarity.setTag('key', 'value');
  clarity.upgrade('upgradeReason');
  if (clarity.hasStarted()) {
    clarity.identify('USER_ID', { userProperty: 'value' });
  }
}


Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <React.StrictMode>
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </Provider>
      </BrowserRouter>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
